import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ArticlesInAllMagasin from "../../../Services/Admin/ArticlesInAllMagasin";
import Strip from "../../../components/Strip";
import SideBareMagasin from "../SideBareMagasin/SideBareMagasin";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";
import axios from "axios";
import DefaulteImage from "../../Utilisateure/visiteur/DefaulteImage.jpeg";
import { getFormattedImageUrl, handleImageError } from "../../../Services/ImageUrlHelper";
import ArticlesLoader from "../../../components/ArticlesLoader";
/* ─── Commission resolution ─── */
function resolveCommission(rules: any[], myMagasin?: string, productMagasin?: string): number {
  const glob = rules.find((r: any) => r.commission_type === 'global');
  return glob ? parseFloat(glob.commission_value) || 0 : 0;
}
function calcPrice(price: any, pct: number): string {
  const p = parseFloat(String(price).replace(',', '.'));
  if (isNaN(p)) return '0.00';
  const total = p + (p * pct / 100);
  const truncated = Math.floor(total * 100 + 0.00001) / 100;
  return truncated.toFixed(2);
}

export default function ArticlesMagasin() {
  const { magasinName } = useParams();
  const [articles, setArticles] = useState<any[]>([]);
  const [filteredArticles, setFilteredArticles] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const MagasinName = localStorage.getItem("MagasinName");

  /* ── commission rules ── */
  const [commRules, setCommRules] = useState<any[]>([]);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/commission`)
      .then(r => setCommRules(r.data || []))
      .catch(() => setCommRules([]));
  }, []);
  const getComm = (proMagasin: string) => resolveCommission(commRules, MagasinName || '', proMagasin || '');

  useEffect(() => {
    if (!magasinName) return;

    const fetchArticles = async () => {
      setLoading(true);
      try {
        const response = await ArticlesInAllMagasin().GatAllArticle();
        const allArticles = response.data?.products || [];

        if (!Array.isArray(allArticles)) {
          console.error("Expected an array but got:", typeof allArticles, allArticles);
          setArticles([]);
          setFilteredArticles([]);
          return;
        }

        const filtered = allArticles.filter(
          (product) =>
            product.NomMagasin?.trim().toLowerCase() === magasinName?.trim().toLowerCase()
        );

        setArticles(filtered);
        setFilteredArticles(filtered);
      } catch (error) {
        console.error("Error fetching articles:", error);
      } finally {
        setTimeout(() => setLoading(false), 500);
      }
    };

    fetchArticles();
  }, [magasinName]);

  useEffect(() => {
    if (!search.trim()) {
      setFilteredArticles(articles);
    } else {
      const searchTerm = search.toLowerCase().trim();
      const filtered = articles.filter(
        (pro) =>
          pro.Designation.toLowerCase().includes(searchTerm) ||
          pro.DesignationAr?.toLowerCase().includes(searchTerm) ||
          pro.RefArticle.toLowerCase().includes(searchTerm)
      );
      setFilteredArticles(filtered);
      setCurrentPage(1); // Reset to first page on new search
    }
  }, [search, articles]);

  const handleGoBack = () => {
    window.history.back();
  };

  /** 🔥 Pagination Logic */
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentArticles = filteredArticles.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () => {
    if (indexOfLastItem < filteredArticles.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <NewSideBarMagasins />

      {loading ? (
        <ArticlesLoader />
      ) : (
        <div className="container">
          <div className="barRetour">
            <span className="iconRetour">
              <Link to={""} onClick={handleGoBack}>
                <i className="bi bi-arrow-left-short"></i>
              </Link>
              <h2>Les articles trouvés dans {magasinName}</h2>
            </span>
          </div>

          <div className="container part-search-trier">
            <div className="search-new" style={{ width: "40vw" }}>
              <i className="bi bi-search position-absolute" style={{ fontSize: "1.4rem", transform: "translateY(-50%)", marginLeft: "36%", marginTop: "2%" }} />
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="form-control w-100"
                placeholder="Recherchez un produit, ref..."
              />
            </div>
          </div>

          {currentArticles.length > 0 ? (
            <div className="row row-desktop mt-4" style={{ width: "93%" }}>
              {currentArticles.map((pro) => {
                const proMagasin = pro.NomMagasin || magasinName || "";
                const isMyProduct = Boolean(
                  MagasinName && proMagasin && MagasinName.trim().toLowerCase() === proMagasin.trim().toLowerCase()
                );
                return (
                  <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={pro.id}>
                    <Link className="product-link" to={""}>
                      <div className="u-card">
                        <div className="u-off">
                          <span className="off">25% off</span>
                        </div>
                        <img
                          src={getFormattedImageUrl(pro.urlImage || pro.UrlImage || pro.image || pro.Image)}
                          alt={pro.Designation}
                          className="u-card-img"
                          onError={handleImageError}
                        />
                        <div className="u-card-icons">
                          <i className="bi bi-suit-heart u-heart"></i>
                          {!isMyProduct && <i className="bi bi-cart u-card-shopping"></i>}
                        </div>
                      <div className="u-km">
                        <p>À 10 Km de chez vous</p>
                      </div>
                      <div className="u-star">
                        <i className="bi bi-star-fill u-i-star"></i>
                        <i className="bi bi-star-fill u-i-star"></i>
                        <i className="bi bi-star-fill u-i-star"></i>
                        <i className="bi bi-star-fill u-i-star"></i>
                        <i className="bi bi-star-fill u-i-star"></i>
                      </div>
                      <div className="u-card-title">
                        {pro.Designation}{pro.DesignationAr ? ` | ${pro.DesignationAr}` : ""}
                      </div>
                      <p className="u-card-ref-ar">Ref : {pro.RefArticle}</p>
                    </div>
                  </Link>
                </div>
              );
            })}
            </div>
          ) : (
            <div className="no-produit mt-5">
              <i className="bi bi-emoji-neutral"></i>
              <br />
              <p>Malheureusement, on n‘a pas ce produit pour l’instant.</p>
              <br />
            </div>
          )}

          {/* 🔥 Pagination Controls */}
          {filteredArticles.length > itemsPerPage && (
            <div className="pagination d-flex justify-content-center mt-4">
              <button className="btn btn-outline-primary mx-2" onClick={prevPage} disabled={currentPage === 1}>
                <i className="bi bi-chevron-left"></i> Précédent
              </button>
              <button className="btn btn-outline-primary mx-2" onClick={nextPage} disabled={indexOfLastItem >= filteredArticles.length}>
                Suivant <i className="bi bi-chevron-right"></i>
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
}
